import script from "./PartnerProjectFormStep4.vue?vue&type=script&setup=true&lang=js"
export * from "./PartnerProjectFormStep4.vue?vue&type=script&setup=true&lang=js"

import "./PartnerProjectFormStep4.vue?vue&type=style&index=0&id=8b83397e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8b83397e"]])

export default __exports__